// Copyright (C) 2019 TANNER AG

import gql from "graphql-tag";

export default gql`
    query defaultParameters($language: String = "de") {
        tcoDefaultParameters(language: $language) {
            name
            value
        }
    }
`;



// WEBPACK FOOTER //
// ./src/tco/queries/defaultparameters.js